/* eslint-disable import/prefer-default-export */
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
